import useStateOptions from '@hooks/useStateOptions';

const useStatesForCountry = () => {
    const { data: states } = useStateOptions();

    const getStatesForCountry = countryCode => {
        if (!states) return null;
        return states.filter(o => o.country === countryCode);
    };

    const hasStatesForCountry = countryCode => {
        if (!states) return null;
        return getStatesForCountry(countryCode).length > 0;
    };
    const getCountryForState = stateCode => {
        if (!states || states.length === 0) return null;
        const state = states.find(s => s.value === stateCode);
        if (!state) return '';
        return state.country;
    };

    return { getStatesForCountry, hasStatesForCountry, getCountryForState };
};

export default useStatesForCountry;
